import React from "react"
import Layout from "../../components/Layout"
import Header from "../../components/Header"
import {
  IntegrationListingHero,
  HowIntegrationsWork,
  IntegrationCardsGrid,
  TrustedPartners,
  IntegrationCTA,
} from "../../components/integrations/IntegrationListing"
import IntegrationGuideStripe from "../../components/integrations/IntegrationGuideStripe"
import ThumbnailImage from "../../images/thumbnails/premagic-web-square.png"

export default function IntegrationsPage() {
  return (
    <Layout
      title="Premagic Integrations | Connect Your Event Stack"
      description="Seamless integrations with leading event management platforms. Sync attendees, auto-generate personalized posters, and drive referral-based registrations."
      keywords={[
        "event integrations",
        "cvent integration",
        "hubspot events",
        "event marketing automation",
        "attendee advocacy",
        "event tech stack",
        "premagic integrations",
      ]}
      metaImage={ThumbnailImage}
    >
      <Header />
      <IntegrationListingHero />
      <HowIntegrationsWork />
      <IntegrationGuideStripe context="Everything you need to know about how Premagic connects with your event platform" />
      <IntegrationCardsGrid />
      <TrustedPartners />
      <IntegrationCTA />
    </Layout>
  )
}
